export const getParentName = (name) => {
    const index = name.lastIndexOf('.');
    if (index !== -1) {
        return name.substring(0, index);
    }
    return undefined;
};
export const getDefaultSearchFunction = (search) => (spec) => {
    var _a;
    if (search) {
        return Boolean((_a = spec.viewSpec.layoutTitle) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(search.trim().toLowerCase()));
    }
    return true;
};
